import Vue from 'vue'
import Router from 'vue-router'
import store from "@src/_store/store";
// For Verify token
import {isSignedIn} from '@services/AuthServices';

// Verify budget
import {checkIfHasBudget} from '@utils/checkIfHasBudget';

// Login
import Login from '@pages/Login/Login.vue';
import ResetPassword from '@pages/Login/ResetPassword.vue';
import Dashboard from '@pages/b2b/Dashboard/index.vue';
import ConfirmationAccountTest from '@pages/Login/ConfirmAccountTest.vue';

import {globals} from "@src/utils/globals";

// Chat
import Chat from '@pages/b2b/Chat/index.vue';

// Budget
import BudgetRepairGraphic from '@pages/b2b/budget/repair-graphic/index.vue';
import BudgetSummary from '@pages/b2b/budget/BudgetSummary.vue';
import BudgetSummaryEdit from '@pages/b2b/budget/BudgetSummaryEdit.vue';
import BudgetSummaryTestGraphic from '@pages/b2b/budget/testGraphic/index.vue';

// Environmental Management
import EnvironmentalManagement from '@pages/b2b/environmental-management/index.vue';
import EnvironmentalManagementScheduling from '@pages/b2b/environmental-management/Scheduling/index.vue';
import EnvironmentalManagementSchedulingEdit from '@pages/b2b/environmental-management/Scheduling/edit.vue';
import EnvironmentalManagementRouteManagement from '@pages/b2b/environmental-management/RouteManagement/index.vue';
import EnvironmentalManagementRouteManagementEdit from '@pages/b2b/environmental-management/RouteManagement/edit.vue';
import EnvironmentalManagementRouteManagementEditConveyor
    from '@pages/b2b/environmental-management/RouteManagement/editConveyor.vue';
import EnvironmentalManagementRouteManagementHistory
    from '@pages/b2b/environmental-management/RouteManagement/history.vue';
import EnvironmentalManagementRouteManagementHistoryView
    from '@pages/b2b/environmental-management/RouteManagement/viewHistory.vue';
import EnvironmentalManagementDocuments from '@pages/b2b/environmental-management/Documentation/index.vue';
import EnvironmentalManagementEGAR from '@pages/b2b/environmental-management/EGAR/index.vue';
import EnvironmentalManagementEGAREdit from '@pages/b2b/environmental-management/EGAR/edit.vue';
import EnvironmentalManagementEGARNew from '@pages/b2b/environmental-management/EGAR/new.vue';


Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Login,
            name: 'login',
            beforeEnter: async (to, __, next) => {
                let isSigned = await isSignedIn('login');

                if (isSigned) {
                    if (to.query.user && to.query.token) {
                        next(`/backoffice/external-users/edit/${to.query.user}/modules/environmental?token=${to.query.token}`);
                    } else {
                        next('/dashboard');
                    }
                } else {
                    next();
                }
            }
        },
        {
            path: '/login',
            beforeEnter: async (_, __, next) => {
                next('/dashboard');
            }
        },
        {
            path: '/password/reset/:token',
            component: ResetPassword,
            name: 'resetPassword'
        },
        {
            path: '/test-account-verification',
            component: ConfirmationAccountTest,
            name: 'confirmAccountTest'
        },
        {
            path: '/dashboard',
            component: Dashboard,
            name: 'dashboard',
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/chat',
            component: Chat,
            name: 'chat',
            meta: {moduleId: globals.MODULES.CHAT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/vehicle/search',
            name: 'vehicle_Search',
            component: () => import('@pages/b2b/vehicle-search/index.vue'),
            meta: {moduleId: globals.MODULES.VEHICLE_IDENTIFICATION.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn();
                if (isSigned == true) {
                    if (from.name == 'budget-summary' || from.name == 'budget-summary-edit') {
                        if (checkIfHasBudget()) {
                            document.getElementById("invisible-button-route").click();
                        } else {
                            next();
                        }
                    } else {
                        next();
                    }
                } else if (isSigned == false) {
                    next('/')
                }
            }
        },
        {
            path: '/budget',
            name: 'budget',
            component: () => import('@pages/b2b/budget/index.vue'),
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('budget');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/budget/history',
            name: 'budget-history',
            component: () => import('@pages/b2b/budget/history/index.vue'),
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/budget/tyres',
            name: 'budget_tyres',
            component: () => import('@pages/b2b/budget/tyres/index.vue'),
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('budget_tyres');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/budget/tyres/:id/edit',
            name: 'budget_tyres_edit',
            component: () => import('@pages/b2b/budget/tyres/edit.vue'),
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('budget_tyres');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/budget/tyres/:id',
            name: 'budget_tyres_show',
            component: () => import('@pages/b2b/budget/tyres/edit.vue'),
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('budget_tyres');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/budget/repair-service',
            name: 'budget_repair-service',
            component: () => import('@pages/b2b/budget/repair-service/index.vue'),
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('budget_repair-service');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/budget/repair-graphic',
            name: 'budget_repair_graphic',
            component: BudgetRepairGraphic,
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('budget_repair_graphic');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/quotation/repair/graphic/vehicle/html/step/:stepId',
            name: 'budget_test_graphic',
            component: BudgetSummaryTestGraphic,
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('budget_test_graphic');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/budget/next-revision',
            name: 'budget_nextRevision',
            component: () => import('@pages/b2b/budget/next-revision/index.vue'),
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, from, next) => {
                let isSigned = await isSignedIn('budget_nextRevision');
                if (from.name == 'budget-summary') {
                    store.commit('budget/setB2b', {currentStep: 2});
                }
                store.commit('budget/setB2b', {maintenancePlanHtml: {show: false, id: 0}});
                store.commit('techInfo/setTechInfo', {maintenancePlanHtml: {show: false, id: 0}});
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/budget/budget-summary',
            name: 'budget-summary',
            component: BudgetSummary,
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/budget/budget-summary/:id/preview',
            name: 'budget-summary-preview',
            component: BudgetSummary,
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            props: {isPreview: true},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/budget/budget-summary/:id/edit',
            name: 'budget-summary-edit',
            component: BudgetSummaryEdit,
            meta: {moduleId: globals.MODULES.MAINTENANCE_REPAIR_QUOTATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/tech-info',
            name: 'technicalInformation',
            component: () => import('@pages/b2b/tech-info/index.vue'),
            meta: {moduleId: globals.MODULES.TECHNICAL_INFORMATION.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('technicalInformation');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental',
            name: 'environmentalManagement',
            component: EnvironmentalManagement,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/scheduling',
            name: 'environmentalManagementScheduling',
            component: EnvironmentalManagementScheduling,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/scheduling/:id/edit',
            name: 'environmentalManagementSchedulingEdit',
            component: EnvironmentalManagementSchedulingEdit,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/route-management',
            name: 'environmentalManagementRouteManagement',
            component: EnvironmentalManagementRouteManagement,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/route-management/:id/edit',
            name: 'environmentalManagementRouteManagementEditConveyor',
            component: EnvironmentalManagementRouteManagementEditConveyor,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/route-management/history',
            name: 'environmentalManagementRouteManagementHistory',
            component: EnvironmentalManagementRouteManagementHistory,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/route-management/history/:id/view',
            name: 'environmentalManagementRouteManagementHistoryView',
            component: EnvironmentalManagementRouteManagementHistoryView,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/route-management/:id',
            name: 'environmentalManagementRouteManagementEdit',
            component: EnvironmentalManagementRouteManagementEdit,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/documents',
            name: 'environmentalManagementDocuments',
            component: EnvironmentalManagementDocuments,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/egar',
            name: 'environmentalManagementEGAR',
            component: EnvironmentalManagementEGAR,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/egar/:egarNum/edit/:egarCode',
            name: 'environmentalManagementEGAREdit',
            component: EnvironmentalManagementEGAREdit,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/egar/:egarNum/edit/:egarCode/producer',
            name: 'environmentalManagementEGAREditProducer',
            component: EnvironmentalManagementEGAREdit,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/environmental/egar/new',
            name: 'environmentalManagementEGARNew',
            component: EnvironmentalManagementEGARNew,
            meta: {moduleId: globals.MODULES.ENVIRONMENTAL_MANAGEMENT.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('environmentalManagement');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/vehicle-identification',
            name: 'vehicleIdentification',
            component: () => import('@pages/b2b/vehicle-identification/index.vue'),
            meta: {moduleId: globals.MODULES.VEHICLE_IDENTIFICATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('vehicleIdentification');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/planning',
            name: 'planning',
            component: () => import('@pages/b2b/planning/index.vue'),
            meta: {moduleId: globals.MODULES.PLANNING.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('planning');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/planning/create',
            name: 'create-planning',
            component: () => import('@pages/b2b/planning/create-planning/index.vue'),
            meta: {moduleId: globals.MODULES.PLANNING.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('create-planning');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/planning/edit/:planningId',
            name: 'edit-planning',
            component: () => import('@pages/b2b/planning/edit-planning/index.vue'),
            meta: {moduleId: globals.MODULES.PLANNING.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('edit-planning');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/tech-info/maintenance-plan',
            name: 'maintenance-plan',
            component: () => import('@pages/b2b/tech-info/maintenance-plan/index.vue'),
            meta: {moduleId: globals.MODULES.TECHNICAL_INFORMATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('maintenance-plan');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/tech-info/manual',
            name: 'tech-manuals',
            component: () => import('@pages/b2b/tech-info/type-information/tech-manuals/index.vue'),
            meta: {moduleId: globals.MODULES.TECHNICAL_INFORMATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('tech-manuals');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/tech-info/data',
            name: 'tech-data',
            component: () => import('@pages/b2b/tech-info/type-information/tech-data/index.vue'),
            meta: {moduleId: globals.MODULES.TECHNICAL_INFORMATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('tech-data');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/tech-info/repair_times',
            name: 'repair-times',
            component: () => import('@pages/b2b/tech-info/type-information/repair-time/index.vue'),
            meta: {moduleId: globals.MODULES.TECHNICAL_INFORMATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('repair-times');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/tech-info/:request/:id',
            name: 'tech-info-manual',
            component: () => import('@pages/b2b/tech-info/show-manual/index.vue'),
            meta: {moduleId: globals.MODULES.TECHNICAL_INFORMATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('tech-info-manual');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/tech-info/categories-tech-manuals/:request/:id',
            name: 'categories-tech-manuals',
            component: () => import('@pages/b2b/tech-info/cathegories-tech-manuals/index.vue'),
            meta: {moduleId: globals.MODULES.TECHNICAL_INFORMATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn('categories-tech-manuals');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/promo-engine',
            name: 'promo-engine',
            component: () => import('@pages/b2b/promo-engine/index.vue'),
            meta: {moduleId: globals.MODULES.PROMO_ENGINE.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/promo-engine/campaign/create',
            name: 'promo-engine-create-campaign',
            component: () => import('@pages/b2b/promo-engine/campaign-form/index.vue'),
            meta: {moduleId: globals.MODULES.PROMO_ENGINE.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/promo-engine/campaign/:id/edit',
            name: 'promo-engine-edit-campaign',
            component: () => import('@pages/b2b/promo-engine/campaign-form/index.vue'),
            meta: {moduleId: globals.MODULES.PROMO_ENGINE.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/promo-engine/campaign/:id/performance',
            name: 'promo-engine-campaign-performance',
            component: () => import('@pages/b2b/promo-engine/campaign-performance/index.vue'),
            meta: {moduleId: globals.MODULES.PROMO_ENGINE.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/privacy-policy',
            name: 'privacy-policy',
            component: () => import('@pages/b2b/privacy-policy/privacy-policy.vue'),
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/terms-and-conditions',
            name: 'terms-and-conditions',
            component: () => import('@pages/b2b/terms-and-conditions/terms-and-conditions.vue'),
        },
        {
            path: '/vehicle/alerts',
            name: 'vehicle-alerts',
            component: () => import('@pages/b2b/vehicle-alerts/vehicle-alerts.vue'),
            meta: {moduleId: globals.MODULES.VEHICLE_IDENTIFICATION.ID},
            beforeEnter: async (_, __, next) => {
                let isSigned = await isSignedIn();
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/erp',
            name: 'erp',
            component: () => import('@pages/b2b/erp/index.vue'),
            meta: {moduleId: globals.MODULES.ERP.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('erp');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/marketing',
            name: 'marketing',
            component: () => import('@pages/b2b/marketing/index.vue'),
            meta: {moduleId: globals.MODULES.MARKETING.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('marketing');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/mygarage',
            name: 'mygarage',
            component: () => import('@pages/b2b/mygarage/index.vue'),
            meta: {moduleId: globals.MODULES.MY_GARAGE.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('mygarage');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/active-reception',
            name: 'active-reception',
            component: () => import('@pages/b2b/active-reception/index.vue'),
            meta: {moduleId: globals.MODULES.ACTIVE_RECEPTION.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('active-reception');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/active-reception/services',
            name: 'active-reception-services',
            component: () => import('@pages/b2b/active-reception/services-view/index.vue'),
            meta: {moduleId: globals.MODULES.ACTIVE_RECEPTION.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('active-reception');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/active-reception/next-revision',
            name: 'active-reception-next-revision',
            component: () => import('@pages/b2b/active-reception/next-revision/index.vue'),
            meta: {moduleId: globals.MODULES.ACTIVE_RECEPTION.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('active-reception');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/active-reception/planning/create',
            name: 'active-reception-create-planning',
            component: () => import('@pages/b2b/planning/create-planning/index.vue'),
            meta: {moduleId: globals.MODULES.ACTIVE_RECEPTION.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('create-planning');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/active-reception/planning/edit/:planningId',
            name: 'active-reception-edit-planning',
            component: () => import('@pages/b2b/planning/edit-planning/index.vue'),
            meta: {moduleId: globals.MODULES.ACTIVE_RECEPTION.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('edit-planning');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/user-config',
            name: 'user-config',
            component: () => import('@pages/users/index.vue'),
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('user-config');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/user-consumption',
            name: 'user-consumption',
            component: () => import('@pages/users/consumption.vue'),
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('user-config');
                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/request-manager',
            name: 'request-manager',
            component: () => import('@pages/b2b/request-manager/index.vue'),
            meta: {moduleId: globals.MODULES.REQUEST_MANAGER.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn();

                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/request-manager/new',
            name: 'new-request-manager',
            component: () => import('@pages/b2b/request-manager/new-request/index.vue'),
            meta: {moduleId: globals.MODULES.REQUEST_MANAGER.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn();

                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/request-manager/:ticketId',
            name: 'edit-request-manager',
            component: () => import('@pages/b2b/request-manager/edit-request/index.vue'),
            meta: {moduleId: globals.MODULES.REQUEST_MANAGER.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn();

                return isSigned ? next() : next('/');
            }
        },
        {
            path: '/backoffice',
            component: () => import('@pages/backoffice/index.vue'),
            meta: {moduleId: globals.MODULES.BACKOFFICE.ID},
            beforeEnter: async (to, from, next) => {
                let isSigned = await isSignedIn('backoffice');
                return isSigned ? next() : next('/');
            },
            children: [
                {
                    // UserProfile will be rendered inside backoffice <router-view>
                    // when /backoffice is matched
                    path: '',
                    name: 'backoffice-dashboard',
                    component: () => import('@pages/backoffice/dashboard/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    // UserProfile will be rendered inside backoffice <router-view>
                    // when /backoffice/entities is matched
                    path: 'entities',
                    name: 'backoffice-entities',
                    component: () => import('@pages/backoffice/entities-management/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'entities/edit/:id',
                    name: 'backoffice-entities-edit',
                    component: () => import('@pages/backoffice/entities-management/edit-entity/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {

                    path: 'entities/create',
                    name: 'backoffice-entities-create',
                    component: () => import('@pages/backoffice/entities-management/create-entity/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'entities/:id_entities/users',
                    name: 'backoffice-entities-users',
                    component: () => import('@pages/backoffice/entities-management/list-users/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },

                },
                {
                    // UserProfile will be rendered inside backoffice <router-view>
                    // when /backoffice/users is matched
                    path: 'users',
                    name: 'backoffice-users',
                    component: () => import('@pages/backoffice/user-management/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'external-users',
                    name: 'backoffice-external-users',
                    component: () => import('@pages/backoffice/modules-management/environmental-management/external-users/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:id',
                    name: 'backoffice-users-edit',
                    component: () => import('@pages/backoffice/user-management/user-edit/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/:id_entities/create',
                    name: 'backoffice-users-create',
                    component: () => import('@pages/backoffice/user-management/user-create/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:id/modules',
                    name: 'backoffice-users-edit-modules',
                    component: () => import('@pages/backoffice/user-management/user-modules/index.vue'),
                    props: {isPreview: true},
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                // UserProfileModels will be rendered inside backoffice <router-view>
                {
                    path: 'users/edit/:id/modules/vrm',
                    name: 'backoffice-users-modules-vrm',
                    component: () => import('@pages/backoffice/modules-management/vrm/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:id/modules/vrm/new-access',
                    name: 'backoffice-users-modules-vrm-new-access',
                    component: () => import('@pages/backoffice/modules-management/vrm/new-access/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:id/modules/vrm/config-access/:vrm_access_id',
                    name: 'backoffice-users-modules-vrm-config-access',
                    component: () => import('@pages/backoffice/modules-management/vrm/config-access/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:id/modules/tech-info',
                    name: 'backoffice-users-modules-tech-info',
                    component: () => import('@pages/backoffice/modules-management/tech-info/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/supplier-management',
                    name: 'backoffice-users-modules-supplier-management',
                    component: () => import('@pages/backoffice/modules-management/supplier-management/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/supplier-management/upload-history',
                    name: 'backoffice-users-modules-supplier-management-upload-history',
                    component: () => import('@pages/backoffice/modules-management/supplier-management/upload-history/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/supplier-management/upload-history-tyres',
                    name: 'backoffice-users-modules-supplier-management-upload-history-tyres',
                    component: () => import('@pages/backoffice/modules-management/supplier-management/upload-history/tyres.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/:idModule/budget-setting',
                    name: 'backoffice-users-modules-budget-setting',
                    component: () => import('@pages/backoffice/modules-management/budget-setting/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/fast-services',
                    name: 'backoffice-users-modules-fast-services',
                    component: () => import('@pages/backoffice/modules-management/fast-services/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/fast-services/:idService',
                    name: 'backoffice-users-modules-fast-services-editService',
                    component: () => import('@pages/backoffice/modules-management/fast-services/edit.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/fast-services/:idService/:packId',
                    name: 'backoffice-users-modules-fast-services-editService-pack',
                    component: () => import('@pages/backoffice/modules-management/fast-services/pack.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/scheduling',
                    name: 'backoffice-users-modules-scheduling',
                    component: () => import('@pages/backoffice/modules-management/scheduling/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/scheduling/:garageId/garage-config',
                    name: 'backoffice-users-modules-scheduling-garage-config',
                    component: () => import('@pages/backoffice/modules-management/scheduling/garages-config/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/scheduling/:garageId/extra-service-calendar',
                    name: 'backoffice-users-modules-scheduling-extra-service-calendar',
                    component: () => import('@pages/backoffice/modules-management/scheduling/extra-services-calendar/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/scheduling/:garageId/hh-calendar',
                    name: 'backoffice-users-modules-scheduling-hh-calendar',
                    component: () => import('@pages/backoffice/modules-management/scheduling/calendar/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/environmental',
                    name: 'backoffice-users-modules-environmental-pack',
                    component: () => import('@pages/backoffice/modules-management/environmental-management/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'external-users/edit/:userId/modules/environmental',
                    name: 'backoffice-external-users-modules-environmental-pack',
                    component: () => import('@pages/backoffice/modules-management/environmental-management/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/environmental/edit-routes',
                    name: 'backoffice-users-modules-environmental-pack-edit-submodule',
                    component: () => import('@pages/backoffice/modules-management/environmental-management/config-router/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'external-users/edit/:userId/modules/environmental/edit-routes',
                    name: 'backoffice-external-users-modules-environmental-pack-edit-submodule',
                    component: () => import('@pages/backoffice/modules-management/environmental-management/config-router/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/tecdoc',
                    name: 'backoffice-users-modules-tecdoc',
                    component: () => import('@pages/backoffice/modules-management/tecdoc-catalogue/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/webshop',
                    name: 'backoffice-users-modules-webshop',
                    component: () => import('@pages/backoffice/modules-management/webshop/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/planning',
                    name: 'backoffice-users-modules-planning',
                    component: () => import('@pages/backoffice/modules-management/planning/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/planning/user-config/:planningUserId',
                    name: 'backoffice-users-modules-planning-user-config',
                    component: () => import('@pages/backoffice/modules-management/planning/users-config/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/planning/user-create',
                    name: 'backoffice-users-modules-planning-user-create',
                    component: () => import('@pages/backoffice/modules-management/planning/users-create/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/my-garage',
                    name: 'backoffice-users-modules-my-garage',
                    component: () => import('@pages/backoffice/modules-management/my-garage/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/tecdoc-service',
                    name: 'backoffice-users-modules-tecdoc-service',
                    component: () => import('@pages/backoffice/modules-management/tecdoc-service/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/erp',
                    name: 'backoffice-users-modules-erp',
                    component: () => import('@pages/backoffice/modules-management/erp/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/active-reception',
                    name: 'backoffice-users-modules-active-reception',
                    component: () => import('@pages/backoffice/modules-management/active-reception/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/strema',
                    name: 'backoffice-users-modules-strema',
                    component: () => import('@pages/backoffice/modules-management/strema/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/digital-service-book',
                    name: 'backoffice-users-modules-digital-service-book',
                    component: () => import('@pages/backoffice/modules-management/digital-service-book/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/autocom',
                    name: 'backoffice-users-modules-autocom',
                    component: () => import('@pages/backoffice/modules-management/autocom/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/chat',
                    name: 'backoffice-users-modules-chat',
                    component: () => import('@pages/backoffice/modules-management/chat/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'users/edit/:userId/modules/promo-engine',
                    name: 'backoffice-users-modules-promo-engine',
                    component: () => import('@pages/backoffice/modules-management/promo-engine/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'business-indicators',
                    name: 'backoffice-business-indicators',
                    component: () => import('@pages/backoffice/business-indicators/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'definitions',
                    name: 'backoffice-definitions',
                    component: () => import('@pages/backoffice/definitions/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'definitions/vrm-settings',
                    name: 'backoffice-definitions-vrm-settings',
                    component: () => import('@pages/backoffice/definitions/vrm-settings.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'definitions/iva-settings',
                    name: 'backoffice-definitions-iva-settings',
                    component: () => import('@pages/backoffice/definitions/iva-settings.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'notifications',
                    name: 'backoffice-notifications',
                    component: () => import('@pages/backoffice/notifications/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'notifications/create',
                    name: 'backoffice-create-notifications',
                    component: () => import('@pages/backoffice/notifications/create-notification/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'notifications/:type/:notification_id',
                    name: 'backoffice-edit-notifications',
                    component: () => import('@pages/backoffice/notifications/edit-notification/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'tecdoc-catalogue',
                    name: 'backoffice-tecdoc-catalogue',
                    component: () => import('@pages/backoffice/tecdoc/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'tecdoc-catalogue/create-license',
                    name: 'backoffice-tecdoc-license-create',
                    component: () => import('@pages/backoffice/tecdoc/create-license/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'tecdoc-catalogue/update-license/:userId',
                    name: 'backoffice-tecdoc-license-update',
                    component: () => import('@pages/backoffice/tecdoc/update-license/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'mytips',
                    name: 'backoffice-mytips',
                    component: () => import('@pages/backoffice/mytips/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'logs',
                    name: 'backoffice-logs',
                    component: () => import('@pages/backoffice/system-logs/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'user-config',
                    name: 'backoffice-user-config',
                    component: () => import('@pages/users/users-backoffice/index.vue'),
                    beforeEnter: async (_, __, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    },
                },
                {
                    path: 'user-consumption',
                    name: 'backoffice-user-consumption',
                    component: () => import('@pages/users/consumption.vue'),
                    beforeEnter: async (to, from, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    }
                },
                {
                    path: 'users/edit/:userId/modules/request-manager',
                    name: 'backoffice-request-manager',
                    component: () => import('@pages/backoffice/modules-management/request-manager/index.vue'),
                    beforeEnter: async (to, from, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    }
                },
                {
                    path: 'health-checks',
                    name: 'backoffice-health-checks',
                    component: () => import('@pages/backoffice/health-checks/index.vue'),
                    beforeEnter: async (to, from, next) => {
                        let isSigned = await isSignedIn('backoffice');
                        return isSigned ? next() : next('/');
                    }
                }
            ]
        }
    ]
});

router.beforeEach(async (to, from, next) => {
    let isSigned = await isSignedIn();

    if (!to.matched.length) {
        if (isSigned) {
            next('/dashboard');
        } else {
            next('/');
        }
    } else if (to.meta && to.meta.moduleId) {
        const getUserModules = store.state.auth.modules;
        const module = getUserModules.find(m => m.moduleId === to.meta.moduleId);
        if (module && module.isActive && module.isVisible) {
            next();
        } else {
            next('/dashboard');
        }
    } else {
        next();
    }
});

export default router;
